import dayjs from 'dayjs'
import {pageDefaultPageNumber, pageDefaultPageSize, pageDefaultTotal} from '@/common/constants/constants'
import SparkMD5 from 'spark-md5'
import {type TreeDepartmentResponse} from '@/api/system/department'
import {type Dictionary, useDictionaryStore} from '@/stores/dictionary'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {existsToken} from "@/common/utils/token";
import {type CurrentDepartmentResponse} from "@/api/system/employee";

export const deduplication = (arr: any[])  => {
    for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
            if (arr[i] === arr[j]) {
                arr.splice(j, 1)
            }
        }
    }
    return arr
}

export const getFormatPrice = (price?: number) => {
    if (!price) {
        return ''
    }
    if (price <= 0) {
        return ''
    }
    return (price / 100).toFixed(0)
}

export const getTimePeriod = () => {
    // 获取当前时间
    const now = new Date()
    // 获取小时数（24小时制）
    const hour = now.getHours()
    console.log(hour)
    // 定义时间段
    const periods = {
        morning: [0, 11],
        afternoon: [12, 24],
    }
    // 遍历时间段，找到匹配的小时范围
    for (const period in periods) {
        if (period === 'morning') {
            if (hour >= periods.morning[0] && hour <= periods.morning[1]) {
                return period
            }
        } else if (period === 'afternoon') {
            if (hour >= periods.afternoon[0] && hour <= periods.afternoon[1]) {
                return period
            }
        }
        return ''
    }
}

export const getTimestamp = () => {
    return Date.now()
}

export const getCurrentPage = () => {
    let pages = getCurrentPages();
    return pages[pages.length - 1]
}

export const getQuery = (): Record<string, string> => {
    const currentPage = getCurrentPage()
    const route = currentPage.route
    // console.log(route)
    if (route) {
        const [routeName, query] = route.split("?")
        if (query) {
            // console.log(query)
            return query.split('&').reduce((acc, cur) => {
                const [key, value] = cur.split('=')
                acc[key] = value
                return acc
            }, {} as Record<string, string>)
        }
    }
    return {}
}

export const getCurrentYear = () => {
    return getDayjs().format('YYYY')
}

const whiteRouteNameList: string[] = [
    '/pages/pages/customer/customer/login',
]

const errorRouteNameList: string[] = [
    '/pages/pages/error/403',
    '/pages/pages/error/404',
    '/pages/pages/error/500',
]


let isRefresh = true
/**
 *
 * @param commonStore
 * @param userStore
 * @param isSpecialUrl 是否指定 url
 * @param url url
 * @param requireLogin 是否鉴权登录
 */
export const interceptorAuth = async (commonStore, userStore, isSpecialUrl?: boolean, url?: string, requireLogin?: boolean) => {
    // console.log('isRefresh: ', isRefresh)
    console.log("interceptorAuth")
    if (!isSpecialUrl) {
        console.log('isSpecialUrl: ', isSpecialUrl)
        const currentPages = getCurrentPages();
        // console.log(currentPages)
        if (!currentPages || currentPages.length <= 0) {
            await uni.redirectTo({url: '/pages/pages/error/404'})
            return;
        }
        url = currentPages[currentPages.length - 1].route

        if (!url || url === '') {
            console.log('url: ', url)
            await uni.redirectTo({url: '/pages/pages/error/404'})
            return;
        }
    }

    if (!url) {
        url = ''
    }

    if (errorRouteNameList.includes(url)) {
        return;
    }

    // console.log('white:', url, whiteRouteNameList.includes(url))

    // console.log('here2')

    if (isRefresh) {
        // 刷新整个页面
        console.log('1isRefresh: false, existsToken')
        // 缓存基本信息
        try {
            await commonStore.getBaseSetting(true)
        } catch (error) {
            await uni.redirectTo({url: '/pages/pages/error/500'})
        }
        if (existsToken()) {
            // 缓存用户信息
            try {
                await userStore.getCurrent()
                isRefresh = false
                return
            } catch (error) {
                isRefresh = false
                await uni.redirectTo({url: '/pages/pages/error/500'})
            }
        } else {
            if (whiteRouteNameList.includes(url)) {
                return
            } else {
                if (requireLogin) {
                    await uni.navigateTo({url: '/pages/pages/customer/customer/login'})
                }
            }
        }
    } else {
        // 非刷新整个页面
        // console.log('3isRefresh: true, existsToken')
        // 缓存基本信息
        if (!commonStore.infoIsCached) {
            try {
                await commonStore.getBaseSetting()
            } catch (error) {
                console.log('info error')
                await uni.redirectTo({url: '/pages/pages/error/500'})
            }
        }
        // 缓存用户信息
        if (existsToken()) {
            if (!userStore.userIsCached) {
                try {
                    // console.log('getCurrent')
                    await userStore.getCurrent()
                    // console.log(`2isRefresh: ${isRefresh}, existsToken`)
                    return
                } catch (error) {
                    await uni.redirectTo({url: '/pages/pages/error/500'})
                }
            }
        } else {
            if (whiteRouteNameList.includes(url)) {
                return
            } else {
                if (requireLogin) {
                    await uni.navigateTo({url: '/pages/pages/customer/customer/login'})
                }
            }
        }
    }
}

/**
 * 简易深度克隆
 * @param target
 */
export function easyDeepClone<T = any>(target: T): T {
    return JSON.parse(JSON.stringify(target))
}

// export const getRoutePath = (path: string) => {
//     if (!path) {
//         return ''
//     }
//     if (path === '/') {
//         return import.meta.env.VITE_SERVER_CONTEXT || '/'
//     }
//     if (path.startsWith('http')) {
//         return path
//     }
//     if (!path.startsWith('/')) {
//         path = '/' + path
//     }
//     return (import.meta.env.VITE_SERVER_CONTEXT || '') + path
// }

// export const getRouteName = (path: string) => {
//     if (!path) {
//         return ''
//     }
//
//     if (path.startsWith('/')) {
//         path = path.replace('/', '')
//     }
//     return path.replace(/\//g, '_')
// }

export const isHttp = (url?: string) => {
    return !!url?.startsWith('http')
}

export const hasHttpQuery = (url?: string) => {
    return url?.indexOf('?') !== -1
}

export const parseHttp = (url?: string) => {
    return url?.split('?') || []
}

export const concatHttp = (prefixUrl?: string, suffixQuery?: string) => {
    if (prefixUrl && suffixQuery) {
        return prefixUrl + '?' + suffixQuery
    }
    return prefixUrl || ''
}

// export const getRouteKeys = (routeList: RouteRecordRaw[], activeKey: string) => {
//     for (const route of routeList) {
//         if (route.name === activeKey) {
//             return route
//         }
//         if (route.children) {
//             getRouteKeys(route.children, activeKey)
//         }
//     }
// }

// export const confirmModal = (options: {}) => {
//     options = {
//         ...{
//             title: '确定吗?',
//             icon: createVNode(ExclamationCircleOutlined),
//             content: '确定操作吗',
//             okText: '确定',
//             okType: 'primary',
//             okButtonProps: {
//                 danger: true,
//             },
//             cancelText: '取消',
//             async onOk() {},
//         },
//         ...options,
//     }
//     Modal.confirm(options)
// }

// export const deleteConfirmModal = (options: {}) => {
//     confirmModal({
//         icon: createVNode(ExclamationCircleOutlined),
//         content: '确定删除吗',
//         ...options,
//     })
// }

export const formatTimestamp = (timestamp: any, format?: string) => {
    if (!timestamp) {
        return ''
    }
    return getDayjs(timestamp).format(format || 'YYYY-MM-DD HH:mm:ss')
}

export const getDayjs = (date?: dayjs.ConfigType, format?: dayjs.OptionType, locale?: string, strict?: boolean) => {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.tz.setDefault('Asia/Shanghai')
    return dayjs(date, format, locale, strict)
}

export const setAll = (obj, val) => Object.keys(obj).forEach(k => (obj[k] = val))

export const initPage = (options?: {}) => {
    return {
        pageNumber: pageDefaultPageNumber,
        pageSize: pageDefaultPageSize,
        totalSize: pageDefaultTotal,
        ...options,
    }
}

/**
 * 获取文件唯一标识（md5）
 * @param file
 */
export const getFileUnionCode = file => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = () => {
            const arrayBuffer = fileReader.result
            const md5Hash = SparkMD5.ArrayBuffer.hash(arrayBuffer as any)
            resolve(md5Hash)
        }

        fileReader.onerror = error => {
            reject(error)
        }

        fileReader.readAsArrayBuffer(file)
    })
}

/**
 * 获取图片 base64
 * @param image
 * @param callback
 */
export const getImageBase64 = (image: Blob, callback: (base64Url: string) => void) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result as string))
    reader.readAsDataURL(image)
}

// export const reloadToIndex = () => {
//     window.location.href = getRoutePath('/')
// }

export const getDepartmentNamePath = (
    tree?: CurrentDepartmentResponse | TreeDepartmentResponse,
    separator?: string,
) => {
    if (!tree) {
        return ''
    }
    const namePathArray = []
    forEachGetDepartmentNamePath(tree, namePathArray)
    if (!separator) {
        separator = ' / '
    }
    return namePathArray.join(separator)
}

const forEachGetDepartmentNamePath = (
    tree: CurrentDepartmentResponse | TreeDepartmentResponse,
    namePathArray: string[],
) => {
    if (!tree) {
        return
    }
    if (tree.name) {
        namePathArray.push(tree.name)
    }
    if (tree.hasOwnProperty('tree')) {
        tree['tree']?.forEach(item => {
            forEachGetDepartmentNamePath(item, namePathArray)
        })
    }
    if (tree.hasOwnProperty('children')) {
        tree['children']?.forEach(item => {
            forEachGetDepartmentNamePath(item, namePathArray)
        })
    }
}

/**
 * 获取字典
 *
 * @param categoryCodeList
 * @param orKeyList
 */
export const getDictionaries = (categoryCodeList: string[], orKeyList?: string[]) => {
    const dictionaryStore = useDictionaryStore()
    return dictionaryStore.pull(categoryCodeList, orKeyList)
}

/**
 * 获取字典
 * @param categoryCode
 * @param dictionaries
 */
export const getDictionaryByCategoryCode = (categoryCode: string | string[]) => {
    const dictionaryStore = useDictionaryStore()
    const isArray = Array.isArray(categoryCode)
    if (isArray) {
        const arr: any[] = []
        for (let index = 0; index < categoryCode.length; index++) {
            const tempArr = dictionaryStore.map[categoryCode[index]]?.dictionaries?.sort((a, b) =>
                a.sort && b.sort ? b.sort - a.sort : 0,
            ) as any[]
            if (tempArr) {
                arr.push(...tempArr)
            }
        }
        // console.log(arr)
        return arr
    } else {
        return dictionaryStore.map[categoryCode]?.dictionaries?.sort((a, b) => (a.sort && b.sort ? b.sort - a.sort : 0))
    }
}

export const getDictionaryNameByCategoryCode = (value: any, categoryCode: string | string[], dictionaries: {}) => {
    return getDictionaryByCategoryCode(categoryCode)?.find(item => item?.value === value)?.label || value
}

export const getDictionaryValuesByCategoryCode = (categoryCode: string | string[]) => {
    return getDictionaryByCategoryCode(categoryCode)?.map(item => item?.value)
}

export const getDictionaryValueByCategoryCode = (categoryCode: string | string[]) => {
    const values = getDictionaryValuesByCategoryCode(categoryCode)
    if (values && values.length > 0) {
        return values[0]
    }
}

/**
 * 获取字典
 * @param keyList
 */
export const getDictionaryByKey = (key: string | string[]): Dictionary[] => {
    const dictionaryStore = useDictionaryStore()
    const isArray = Array.isArray(key)
    if (isArray) {
        const arr: Dictionary[] = []
        for (let index = 0; index < key.length; index++) {
            const dict = dictionaryStore.keyMap[key[index]]
            if (dict) {
                arr.push(dict)
            }
        }
        return arr
    } else {
        const dict = dictionaryStore.keyMap[key]
        if (dict) {
            return [dict]
        }
        return []
    }
}

export const getDictionaryValueByKey = (key: string | string[]) => {
    const dicts = getDictionaryByKey(key)
    if (dicts && dicts.length > 0) {
        return dicts[0].value
    }
}

export const isNumber = (value: any) => {
    return /^-?\d+$/.test(value)
}

export const isBoolean = (value: any) => {
    return value === true || value === false || toString.call(value) === '[object Boolean]'
}

// export const getImageRender = (downloadUrl: string, width?: number, height?: number) => {
//     const defaultWidth = 60
//     const defaultHeight = 60
//     if (!width) {
//         width = defaultWidth
//     }
//     if (!height) {
//         height = defaultHeight
//     }
//     if (downloadUrl) {
//         return h(
//             Image,
//             {
//                 src: downloadUrl,
//                 width: width,
//                 height: height,
//                 fallback: imageFallback,
//             },
//             {
//                 previewMask: () => h(EyeOutlined),
//             },
//         )
//     } else {
//         return h(
//             Image,
//             {
//                 src: imageFallback,
//                 width: width,
//                 height: height,
//             },
//             {
//                 previewMask: () => h(EyeOutlined),
//             },
//         )
//     }
// }

// export const getMimeTypeCustomerRender = (mimeType, downloadUrl, isFolder) => {
//     mimeType = mimeType || ''
//     const fontSize = 60
//     if (isFolder === YesOrNoEnum.YES) {
//         return h(FolderOutlined, { style: { fontSize: fontSize + 'px' } })
//     } else if (mimeType.startsWith('image/')) {
//         return getImageRender(downloadUrl)
//     } else if (mimeType.indexOf('application/wps-office.xlsx') > -1) {
//         return h(FileExcelOutlined, { style: { fontSize: fontSize + 'px' } })
//     } else if (mimeType.indexOf('application/wps-office.docx') > -1) {
//         return h(FileWordOutlined, { style: { fontSize: fontSize + 'px' } })
//     } else if (mimeType.indexOf('application/wps-office.pptx') > -1) {
//         return h(FilePptOutlined, { style: { fontSize: fontSize + 'px' } })
//     } else {
//         return h(FileUnknownOutlined, { style: { fontSize: fontSize + 'px' } })
//     }
// }

export const imageFallback =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=='
